import loading from './loading'

export default loading
